import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, message } from 'antd';
import { handleApiError } from '../utils/errorHandler';
import {
  PageContainer,
  Card,
  PageTitle,
  FormContainer,
  StyledInput,
  StyledPassword,
  LinksContainer,
  StyledLink,
  ErrorMessage
} from '../styles/SharedStyles';
import { useLanguage } from '../contexts/LanguageContext';
import en from '../locales/en';
import zh from '../locales/zh';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  const t = currentLanguage === 'en' ? en : zh;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    // 密码验证
    if (password !== confirmPassword) {
      setErrorMessage('两次输入的密码不一致');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('https://api.kalimbaflows.com/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || '注册失败');
      }

      message.success('注册成功！请登录');
      navigate('/login');
    } catch (error) {
      const errorMsg = handleApiError(error, '注册失败，请稍后重试');
      setErrorMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <Card>
        <PageTitle>{t.auth.register.title}</PageTitle>
        <FormContainer onSubmit={handleSubmit}>
          <StyledInput
            placeholder={t.auth.register.emailPlaceholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            required
          />
          <StyledPassword
            placeholder={t.auth.register.passwordPlaceholder}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <StyledPassword
            placeholder={t.auth.register.confirmPasswordPlaceholder}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          <Button type="primary" htmlType="submit" loading={loading} block>
            {t.auth.register.registerButton}
          </Button>
          <LinksContainer>
            <StyledLink to="/login">{t.auth.register.hasAccount} {t.auth.register.login}</StyledLink>
          </LinksContainer>
        </FormContainer>
      </Card>
    </PageContainer>
  );
}

export default Register; 